/* eslint-disable @typescript-eslint/no-explicit-any */
import cities from '../../utils/cities'
import COPY from '../../utils/copy'
import Button from '../button'
import { useEffect, useState } from 'react'
import { Formik, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup';
import { toast } from 'react-toastify'
interface FormValues {
  name: string
  phone: string
  email: string
  citizenship: string
  preferredMethod: string
  inquiryType: string
  currentlyInColombia: string
  city: string
  message: string
}

// const validate = (values: FormValues) => {
//   const errors: FormValues = {
//     name: '',
//     phone: '',
//     email: '',
//     citizenship: '',
//     preferredMethod: '',
//     inquiryType: '',
//     currentlyInColombia: '',
//     city: '',
//     message: '',
//   }


//   if (!values.name || values.name.trim().length === 0) {
//     errors.name = COPY.REQUIRED
//   }
//   if (!values.phone) {
//     errors.phone = COPY.REQUIRED
//   }
//   if (values.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
//     errors.email = COPY.INVALID_EMAIL
//   }
//   if (!values.email || values.email === 'placeholder') {
//     errors.email = COPY.REQUIRED
//   }
//   if (!values.citizenship || values.citizenship === 'placeholder') {
//     errors.citizenship = COPY.REQUIRED
//   }
//   if (!values.preferredMethod || values.preferredMethod === 'placeholder') {
//     errors.preferredMethod = COPY.REQUIRED
//   }
//   if (!values.inquiryType || values.inquiryType === 'placeholder') {
//     errors.inquiryType = COPY.REQUIRED
//   }
//   if (!values.currentlyInColombia || values.currentlyInColombia === 'placeholder') {
//     errors.currentlyInColombia = COPY.REQUIRED
//   }
//   if ((values.currentlyInColombia === 'yes' && !values.city) || values.city === 'placeholder') {
//     errors.city = COPY.REQUIRED
//   }
//   if (!values.message) {
//     errors.message = COPY.REQUIRED
//   }

//   return errors
// }

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required'),
  name: Yup.string().required('Name is Required'),
  phone: Yup.string().required('phone is required'),
  preferredMethod: Yup.string().required('preferred Method is required'),
  citizenship: Yup.string().required('citizenship is required'),
  currentlyInColombia: Yup.string().required(),
  city: Yup.string(),
  message: Yup.string().required('message is required')
});

interface Country {
  name: string
  alpha2Code: string
}

const initialValues: FormValues = {
  name: '',
  email: '',
  phone: '',
  preferredMethod: '',
  citizenship: '',
  inquiryType: '',
  currentlyInColombia: '',
  city: '',
  message: '',
};

export default function ContactForm() {
  const [isSubmitting] = useState<Boolean>(false)
  const [countries, setCountries] = useState<Country[]>([])

  useEffect(() => {
    fetch('https://restcountries.com/v2/all')
      .then((response) => response.json())
      .then((data) => {
        const countries = data.map((country: any) => ({
          name: country.name,
          code: country.alpha2Code,
        }))
        setCountries(countries)
      })
      .catch((error) => console.error(error))
  }, [])

  // const MyForm: React.FC = () => {
  //   const onSubmit = (values: FormValues) => {
  //     console.log(values);
  //   };
  // }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        fetch(`https://api.colvisahelp.com/submit/submit`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            contact: {
              ...values
            }
          }),

        })
          .then(
            res => res.json()
          ).then(data => {
            toast.success(data, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          })
          .catch(err => toast.error(err, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }))
      }}
    >
      {(formik) => {
        console.log()
        return (
          <form onSubmit={formik.handleSubmit}>
            <div className='grid grid-cols-1 sm:grid-cols-2 gap-4 justify-items-center w-4/5 xl:w-1/2 h-full pt-12 xl:pt-24 mx-auto'>
              <div className='w-full flex flex-col items-start my-2 sm:my-4'>
                <label className='mb-2'>{COPY.NAME_LABEL}</label>
                <Field
                  name='name'
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  className='py-2.5 w-full rounded-md bg-gray-100 shadow hover:shadow-lg pl-4 text-black placeholder:text-gray-500 outline-none border-2 border-gray-200'
                  placeholder={COPY.NAME_PLACEHOLDER}
                />
                <div className='ml-2 text-xs mt-0.5'>
                  <ErrorMessage name='name' component='span' className='text-red-500' />
                </div>
              </div>
              <div className='w-full flex flex-col items-start my-2 sm:my-4'>
                <label className='mb-2'>{COPY.EMAIL_LABEL}</label>
                <Field
                  name='email'
                  onChange={formik.handleChange}
                  value={formik.values.email}
                  className='py-2.5 w-full rounded-md bg-gray-100 shadow hover:shadow-lg pl-4 text-black placeholder:text-gray-500 outline-none border-2 border-gray-200'
                  placeholder={COPY.EMAIL_PLACEHOLDER}
                />
                <div className='ml-2 text-xs mt-0.5'>
                  <ErrorMessage name='email' component='span' className='text-red-500' />
                </div>
              </div>
              <div className='w-full flex flex-col items-start my-2 sm:my-4'>
                <label className='mb-2'>{COPY.PHONE_LABEL}</label>
                <Field
                  name='phone'
                  onChange={formik.handleChange}
                  value={formik.values.phone}
                  className='py-2.5 w-full rounded-md bg-gray-100 shadow hover:shadow-lg pl-4 text-black placeholder:text-gray-500 outline-none border-2 border-gray-200'
                  placeholder={COPY.PHONE_PLACEHOLDER}
                />
                <div className='ml-2 text-xs mt-0.5'>
                  <ErrorMessage name='phone' component='span' className='text-red-500' />
                </div>
              </div>
              <div className='w-full flex flex-col items-start my-2 sm:my-4'>
                <label className='mb-2'>{COPY.PREFERRED_LABEL}</label>
                <Field
                  as='select'
                  name='preferredMethod'
                  onChange={formik.handleChange}
                  value={formik.values.preferredMethod}
                  className='py-2.5 w-full rounded-md bg-gray-100 shadow hover:shadow-lg pl-4 text-black placeholder:text-gray-500 outline-none border-2 border-gray-200'
                >
                  <option value='placeholder'>{COPY.SELECT_PREFERRED_METHOD}</option>
                  <option>{COPY.BY_WHATSAPP_CALL}</option>
                  <option>{COPY.BY_WHATSAPP_MESSAGE}</option>
                  <option>{COPY.BY_EMAIL}</option>
                  <option>{COPY.VIA_ZOOM_MEETING}</option>
                  <option>{COPY.VIA_GOOGLE_MEETS_MEETING}</option>
                </Field>
                <div className='ml-2 text-xs mt-0.5'>
                  <ErrorMessage name='preferredMethod' component='span' className='text-red-500' />
                </div>
              </div>
              <div className='w-full flex flex-col items-start my-2 sm:my-4'>
                <label className='mb-2'>What is your country of citzenship?</label>
                <Field
                  as='select'
                  name='citizenship'
                  onChange={formik.handleChange}
                  value={formik.values.citizenship}
                  className='py-2.5 w-full rounded-md bg-gray-100 shadow hover:shadow-lg pl-4 text-black placeholder:text-gray-500 outline-none border-2 border-gray-200'
                >
                  <option value='placeholder'>{COPY.SELECT_A_COUNTRY}</option>
                  {countries.map((country: any) => (
                    <option key={country.code} value={country.code}>
                      {country.name}
                    </option>
                  ))}
                </Field>
                <div className='ml-2 text-xs mt-0.5'>
                  <ErrorMessage name='citizenship' component='span' className='text-red-500' />
                </div>
              </div>
              <div className='w-full flex flex-col items-start my-2 sm:my-4'>
                <label className='mb-2'>{COPY.INQUIRY_TYPE_LABEL}</label>
                <Field
                  as='select'
                  onChange={formik.handleChange}
                  value={formik.values.inquiryType}
                  className='py-2.5 w-full rounded-md bg-gray-100 shadow hover:shadow-lg pl-4 text-black placeholder:text-gray-500 outline-none border-2 border-gray-200'
                  name='inquiryType'
                >

                  <option value='placeholder'>{COPY.SELECT_INQUIRY_TYPE}</option>
                  <option value='disabled' disabled>
                    Visa Related Services
                  </option>
                  <option value='touristVisas'>Tourist Visas</option>
                  <option value='migrantVisas'>Migrant Visas</option>
                  <option value='residentVisas'>Resident Visas</option>
                  <option value='disabled' disabled>
                    Immigration Related Services
                  </option>
                  <option value='cedulaDeExtranjeria'>Cedula De Extranjeria</option>
                  <option value='touristPermitExtension'>Tourist Permit Extension</option>
                  <option value='salvoconducto'>Salvoconducto</option>
                  <option value='marriageUnionMartialDeHecho'>Marriage: Union Martial De Hecho</option>
                  <option value='certificateOfMigratoryMovements'>
                    Certificate Of Migratory Movements
                  </option>
                  <option value='disabled' disabled>
                    US Citizen Services
                  </option>
                  <option value='colombianLegalizationOfDocuments'>US Passport Renewal</option>
                  <option value='disabled' disabled>
                    Document Related Services
                  </option>
                  <option value='colombianLegalizationOfDocuments'>
                    Colombian Legalization Of Documents
                  </option>
                  <option value='colombianApostilles'>Colombian Apostilles</option>
                  <option value='officialTranslation'>Official Translations</option>
                  <option value='disabled' disabled>
                    Other
                  </option>
                  <option value='generalQuestion'>General Question</option>
                  <option value='requestQuote'>Request A Quote</option>
                  <option value='legalConcern'>Legal Concern</option>
                </Field>
                <div className='ml-2 text-xs mt-0.5'>
                  <ErrorMessage name='citizenship' component='span' className='text-red-500' />
                </div>
              </div>
              <div className='w-full flex flex-col items-start my-2 sm:my-4'>
                <label className='mb-2'>{COPY.CURRENTLY_IN_COLOMBIA_LABEL}</label>
                <Field
                  as='select'
                  name='currentlyInColombia'
                  className='py-2.5 w-full rounded-md bg-gray-100 shadow hover:shadow-lg pl-4 text-black placeholder:text-gray-500 outline-none border-2 border-gray-200'
                  value={formik.values.currentlyInColombia}
                  onChange={formik.handleChange}
                >
                  <option value='placeholder'>{COPY.SELECT_AN_OPTION}</option>
                  <option value='yes'>{COPY.YES}</option>
                  <option value='no'>{COPY.NO}</option>
                </Field>
                <div className='ml-2 text-xs mt-0.5'>
                  <ErrorMessage
                    name='currentlyInColombia'
                    component='span'
                    className='text-red-500'
                  />
                </div>
              </div>
              {formik?.values?.currentlyInColombia === 'yes' && <div className='w-full flex flex-col items-start my-2 sm:my-4'>
                <label className='mb-2'>{COPY.CITY_LABEL}</label>
                <Field
                  as='select'
                  name='city'
                  onChange={formik.handleChange}
                  value={formik.values.city}
                  className='py-2.5 w-full rounded-md bg-gray-100 shadow hover:shadow-lg pl-4 text-black placeholder:text-gray-500 outline-none border-2 border-gray-200'
                >
                  <option value='placeholder'>{COPY.SELECT_A_CITY}</option>
                  {cities.map((city) => (
                    <option key={city.id} value={city.id}>
                      {city.name}
                    </option>
                  ))}
                </Field>
                <div className='ml-2 text-xs mt-0.5'>
                  <ErrorMessage name='city' component='span' className='text-red-500' />
                </div>
              </div>}
            </div>
            <div className='grid grid-cols-1 gap-4 justify-items-center w-4/5 xl:w-1/2 h-full mx-auto mt-4 pb-12 xl:pb-24'>
              <div className='w-full flex flex-col items-start my-2 sm:my-4'>
                <label className='mb-2'>{COPY.MESSAGE_LABEL}</label>
                <Field
                  name='message'
                  onChange={formik.handleChange}
                  value={formik.values.message}
                  as='textarea'
                  className='h-32 py-2.5 w-full rounded-md bg-gray-100 shadow hover:shadow-lg pl-4 text-black placeholder:text-gray-500 outline-none border-2 border-gray-200'
                  placeholder={COPY.MESSAGE_PLACEHOLDER}
                />
                <div className='ml-2 text-xs mt-0.5'>
                  <ErrorMessage name='message' component='span' className='text-red-500' />
                </div>
              </div>
              {/* {formik.isValid && ( */}
              <Button
                // disabled={!formik.isValid || isSubmitting}
                type='submit'
                content={isSubmitting ? COPY.SUBMITTING : COPY.SUBMIT_INQUIRY}
              />
              {/* )} */}
            </div>
          </form>
        )
      }}
    </Formik>
  )
}
